import { useEffect, useState } from "react";
import { Body } from "@vds/typography";
import { useSelector } from "react-redux";
import { getTagName } from "../../../model/reportService";
import DisplayCanvas from "../../../polygonLib/displayPolygonLib/displayCanvas";
import { transformPolygonData } from "../../../global/utility/roiUtils";
import { colorMapping } from "../../../global/utility/Utils";
import { Toggle } from "@vds/toggles";

export const AdvanceConfigAccordion = ({
  state,
  imageUrl,
  imageSize,
  newListTotal,
  isLoading,
  cvappid,
}) => {
  const tagIdList = useSelector((state) => {
    return state.sitesReducer.tagIdList;
  });
 const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList) || [];
 const cvAppEventInfo = cvAppList.filter((item) => item.id === cvappid);

  const [displayColors, setDisplayColors] = useState([]);
  const [cvAppNestedData, setcvAppNestedData] = useState([]);

 const findAndPrintNestedKey =(data, targetKey) => {
  if (Array.isArray(data)) {
    data.forEach(item => findAndPrintNestedKey(item, targetKey));
  } else if (typeof data === 'object' && data !== null) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (key === targetKey) {
          setcvAppNestedData(data[key])
        }
        findAndPrintNestedKey(data[key], targetKey);
      }
    }
  }
}

useEffect(()=> {
findAndPrintNestedKey(cvAppEventInfo, 'deploy-parameters');
}, [])

  const newList = newListTotal?.deploymentConfig;
  const deployParams = newList?.[0]?.config?.["deploy-parameters"];
  const hasDeployParams = Array.isArray(newList) && newList.length > 0 && deployParams && Object.keys(deployParams).length > 0;
  const schemaProperties = cvAppNestedData?.properties || {};
  const hasContent = hasDeployParams && Object.keys(deployParams).some(key =>
    key === "colors" || schemaProperties[key]?.description
  );

  if (!hasContent) {
    return (
      <Body color="#A7A7A7" bold={true} size="large">
        No advanced configuration
      </Body>
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "1rem",
          alignItems: "stretch",
          marginBottom: "1rem",
        }}
      >
        <div>
          
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {
            Object.entries(newList[0].config["deploy-parameters"]).map(
              ([key, value]) => {
                let newValue;
                if (Array.isArray(value)) {
                  let message = "";
                  value.forEach((e, index) => {
                    message =
                      message +
                      e +
                      `${index === value.length - 1 ? "" : ", "}`;
                  });
                  newValue = message;
                } else {
                  newValue = value;
                }
                const cvAppNestedDataKeys = Object.keys(cvAppNestedData).length !== 0 && Object?.keys(cvAppNestedData?.properties)
                const comparisonResults = cvAppNestedDataKeys.length > 0 && cvAppNestedDataKeys?.map(word => {
                  return word === key;
                });
                const fieldLabel = cvAppNestedData?.properties?.[key]?.description;
                if (key === "colors") {
                  value.forEach((item) => {
                    const colorsCode = colorMapping(item);
                    if (!displayColors?.includes(colorsCode)) {
                      setDisplayColors((prevObjects) => [
                        ...prevObjects,
                        colorsCode,
                      ]);
                    }
                  });
                }
                return (
                  <div
                    style={{
                      display: "flex",
                      fontSize: "16px"
                    }}
                  >
                    {cvAppEventInfo[0].image === "UnattendedObjectDetection" ? (
                      <Body size="large">
                        {comparisonResults &&
                        key !== "colors" &&
                        typeof newValue !== "boolean" &&
                        key !== "unattended_time_frame" &&
                        key !== "min_association_time" ? (
                          <span>
                            {" "}
                            <b>{fieldLabel}</b> : {newValue}{" "}
                          </span>
                        ) : key === "min_association_time" ? (
                          <span>
                            <span style={{ marginRight: "20px" }}>
                              <b>{cvAppNestedData?.properties?.min_association_time.properties.min_proximity_period.description}</b> :{" "}
                              {newValue?.min_proximity_period}
                            </span>
                            <span>
                              <b>{cvAppNestedData?.properties?.min_association_time.properties.units.description}</b> : {newValue?.units}
                            </span>
                          </span>
                        ) : (
                          key === "unattended_time_frame" && (
                            <span>
                              <span style={{ marginRight: "20px" }}>
                                <b>{cvAppNestedData?.properties?.unattended_time_frame.properties.zone_verification_period.description}</b> :{" "}
                                {newValue?.zone_verification_period}
                              </span>
                              <span>
                                <b>{cvAppNestedData?.properties?.unattended_time_frame.properties.units.description}</b> : {newValue?.units}
                              </span>
                            </span>
                          )
                        )}
                      </Body>
                    ) : (
                      <Body size="large">
                        {comparisonResults &&
                          key !== "colors" &&
                          typeof newValue !== "boolean" &&
                          key !== "zone1" &&
                          key !== "zone2" &&
                          fieldLabel && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                gap: "15px"
                              }}
                            >
                              <span>
                               <b>{fieldLabel}</b></span> : <span>{newValue}{" "}
                              </span>
                            </div>
                          )}
                        {comparisonResults &&
                          key !== "colors" &&
                          typeof newValue == "boolean" &&
                          key !== "zone1" &&
                          key !== "zone2" &&
                          fieldLabel && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                gap: "15px"
                              }}
                            >
                              <span>
                                <b>{fieldLabel}</b>
                              </span>{" "}
                              :{" "}
                              <Toggle
                                on={newValue}
                                surface="light"
                                showText={false}
                                textWeight="regular"
                                textSize="small"
                                textPosition="right"
                                statusText={(e) => (e ? "Alert On" : "Alert Off")}
                                data-testid="ruleDetails_ruleToggle"
                                disabled={false}
                                onChange={() => {}}
                              />{" "}
                            </div>
                          )}
                        {key === "colors" && (
                          <div>
                            <span
                              style={{
                                position: "relative",
                                float: "left",
                                margin: "10px 0px",
                                width: "100%",
                                fontWeight: "bold",
                                color: "#747272"
                              }}
                            >
                              Colors selected for detection
                            </span>
                            <p style={{ marginBottom: "5px", float: "left" }}>
                              {displayColors.map((color) => {
                                return (
                                  <span
                                    style={{
                                      backgroundColor: color,
                                      width: "20px",
                                      height: "20px",
                                      float: "left",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      borderRadius: "50px"
                                    }}
                                  ></span>
                                );
                              })}
                            </p>
                          </div>
                        )}
                      </Body>
                    )}
                  </div>
                );

              })
          }
        </div>
      </div>
    </>
  );
};

export default AdvanceConfigAccordion;
